import { css, keyframes } from 'styled-components';
import { rgba } from 'polished';
import { NotificationType } from '../notifications/notificationType.enum';
import { CSSProperties } from 'react';

export const COLORS = {
    rakutenRed: '#bf0000',
    redTitle: '#DF0101',
    warningBackground: '#FEF3EB',
    hoverBackground: '#f7f7f7',
    lightRed: '#ff1212',
    darkRed: '#960000',
    white: '#ffffff',
    dark: '#000000',
    dark1: '#333333',
    dark2: '#4d4d4d',
    grey: '#7F7F7F',
    lightGrey: '#dddddd',
    grey2: '#f5f5f5',
    grey3: '#D1D1D1',
    grey4: '#b2b2b2',
    grey5: '#606060',
    grey9: '#DaDaDa',
    grey6: '#9c9c9c',
    grey7: '#686868',
    grey8: '#ebebeb',
    ultralightGrey: '#f8f8f8',
    orange: '#ff5700',
    green: '#069907',
    success: '#047205',
    blue: '#00a0f0',
    fbBlue: '#3b579d',
    linkBlue: '#006A9E',
    error: '#DF0101',
    warning: '#995E00',
    darkPurple: '#240b34',
    lineColor: '#EF8080',
    rakutenPink: '#feefef',
    yellow: '#f8b34d',
    lightBlue: '#134FF3',
    pink: '#FFDBDB',
    notificationBannerBackground: '#dcf3ff',
    notificationBannerText: '#00334d',
};

export const NOTIFICATIONS = {
    [NotificationType.Error]: {
        background: '#FFDBDB',
        color: '#FF3939',
        icon: [
            'M1019.501 885.523l-478.514-776.485c-5.317-9.813-17.28-15.946-29.243-15.946s-22.597 6.133-29.243 15.946l-478.514 775.258c-5.317 9.813-5.317 20.854 0 30.667 6.646 9.813 17.28 15.946 29.243 15.946h957.028c11.963 0 22.597-6.133 29.243-14.72 5.317-9.813 6.646-20.854 0-30.667zM535.273 758.027c0 18.619-10.752 33.247-24.437 33.247s-24.437-14.628-24.437-33.247v-26.597c0-18.619 10.752-33.247 24.437-33.247s24.437 14.628 24.437 33.247v26.597zM535.273 622.546c0 16.291-10.752 29.091-24.437 29.091s-24.437-12.8-24.437-29.091v-221.091c0-16.291 10.752-29.091 24.437-29.091s24.437 12.8 24.437 29.091v221.091z',
        ],
        expiry: 10000,
    },
    [NotificationType.Warning]: {
        background: '#FEF3EB',
        color: '#F16A00',
        icon: [
            'M476 764H548V440H476V764ZM512 260C482.192 260 458 284.192 458 314 458 343.808 482.192 368 512 368 541.808 368 566 343.808 566 314 566 284.192 541.808 260 512 260ZM512 944C273.788 944 80 750.21 80 512 80 273.788 273.788 80 512 80 750.21 80 944 273.788 944 512 944 750.21 750.21 944 512 944ZM512 8C233.648 8 8 233.648 8 512 8 790.352 233.648 1016 512 1016 790.352 1016 1016 790.352 1016 512 1016 233.648 790.352 8 512 8Z',
        ],
        expiry: 10000,
    },
    [NotificationType.Redirecting]: {
        background: '#FEF3EB',
        color: '#F16A00',
        icon: [
            'M476 764H548V440H476V764ZM512 260C482.192 260 458 284.192 458 314 458 343.808 482.192 368 512 368 541.808 368 566 343.808 566 314 566 284.192 541.808 260 512 260ZM512 944C273.788 944 80 750.21 80 512 80 273.788 273.788 80 512 80 750.21 80 944 273.788 944 512 944 750.21 750.21 944 512 944ZM512 8C233.648 8 8 233.648 8 512 8 790.352 233.648 1016 512 1016 790.352 1016 1016 790.352 1016 512 1016 233.648 790.352 8 512 8Z',
        ],
    },
    [NotificationType.Success]: {
        background: '#EBF7EC',
        color: '#047205',
        icon: [
            'M965.6 227.107 919.786 181.293 350 751.049 104.214 505.293 58.4 551.107 350 842.707 965.6 227.107Z',
        ],
        expiry: 3000,
    },
    [NotificationType.Success_Redirecting]: {
        background: '#EBF7EC',
        color: '#047205',
        icon: [
            'M965.6 227.107 919.786 181.293 350 751.049 104.214 505.293 58.4 551.107 350 842.707 965.6 227.107Z',
        ],
        expiry: 5000,
    },
};

export const MQS = {
    mq1Min: '0',
    mq1Max: '599px',
    mq2Min: '600px',
    mq2Max: '899px',
    mq3Min: '900px',
    mq3Max: '1199px',
    mq4Min: '1200px',
    mq4Max: '1599px',
    mq5Min: '1600px',
};

export const BREAKPOINTS = {
    mq1: `(min-width: ${MQS.mq1Min}) and (max-width: ${MQS.mq1Max})`,
    mq2: `(min-width: ${MQS.mq2Min}) and (max-width: ${MQS.mq2Max})`,
    mq3: `(min-width: ${MQS.mq3Min}) and (max-width: ${MQS.mq3Max})`,
    mq4: `(min-width: ${MQS.mq4Min}) and (max-width: ${MQS.mq4Max})`,
    mq5: `min-width: ${MQS.mq5Min}`,
};

export const EXTENDS = {
    isVisualyHidden: css`
        position: absolute !important;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip: rect(1px, 1px, 1px, 1px);
    `,
    overlay: css`
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: ${rgba('#000000', 0.7)};
        z-index: 10;
        display: flex;
        transition: opacity 0.3s ease-in-out;
    `,
    overlayLight: css`
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: ${rgba('#f8f8f8', 0.8)};
        z-index: 10;
        display: flex;
        transition: opacity 0.3s ease-in-out;
    `,
};

export const SPACINGS = {
    base: 8,
};

export const SIZES = {
    appMaxWidth: 1080,
};

export const ANIMATIONS = {
    FadeIn: keyframes`
        from {
            opacity: 0;
        }
        
        to {
            opacity: 100%;
        }
    `,
};

export const SHADOWS = {
    level1: '0px 2px 5px rgba(0, 0, 0, 0.05)',
    level3: '0px 4px 3px rgba(0, 0, 0, 0.02)',
    level30: '0px 4px 3px rgba(0, 0, 0, 0.2);',
};

export const FONT_FAMILY = {
    multipleRegularCss: css`
        &:lang(en),
        &:lang(uk),
        &:lang(es),
        &:lang(de),
        &:lang(ja),
        &:lang(auto),
        &:lang(th),
        &:lang(id),
        &:lang(vi) {
            font-family: 'Rakuten Sans UI Regular', 'Noto Sans JP', 'Noto Sans SC', 'Noto Sans TC',
                sans-serif;
        }
        &:lang(zh-CN) {
            font-family: 'Rakuten Sans UI Regular', 'Noto Sans SC', 'Noto Sans TC', 'Noto Sans JP',
                sans-serif;
        }
        &:lang(zh-TW),
        &:lang(zh-HK) {
            font-family: 'Rakuten Sans UI Regular', 'Noto Sans TC', 'Noto Sans SC', 'Noto Sans JP',
                sans-serif;
        }
        &:lang(ko) {
            font-family: 'Ko UI', sans-serif;
        }
    `,
    multipleBoldCss: css`
        &:lang(en),
        &:lang(uk),
        &:lang(es),
        &:lang(de),
        &:lang(ja),
        &:lang(auto),
        &:lang(th),
        &:lang(id),
        &:lang(vi) {
            font-family: 'Rakuten Sans UI Bold', 'Noto Sans JP', 'Noto Sans SC', 'Noto Sans TC',
                sans-serif;
        }
        &:lang(zh-CN) {
            font-family: 'Rakuten Sans UI Bold', 'Noto Sans SC', 'Noto Sans TC', 'Noto Sans JP',
                sans-serif;
        }
        &:lang(zh-TW),
        &:lang(zh-HK) {
            font-family: 'Rakuten Sans UI Bold', 'Noto Sans TC', 'Noto Sans SC', 'Noto Sans JP',
                sans-serif;
        }
        &:lang(ko) {
            font-family: 'Ko UI', sans-serif;
        }
    `,
    multipleSemiBoldCss: css`
        &:lang(en),
        &:lang(uk),
        &:lang(es),
        &:lang(de),
        &:lang(ja),
        &:lang(auto),
        &:lang(th),
        &:lang(id),
        &:lang(vi) {
            font-family: 'Rakuten Sans UI Semi-Bold', 'Noto Sans JP', 'Noto Sans SC', 'Noto Sans TC',
                sans-serif;
        }
        &:lang(zh-CN) {
            font-family: 'Rakuten Sans UI Semi-Bold', 'Noto Sans SC', 'Noto Sans TC', 'Noto Sans JP',
                sans-serif;
        }
        &:lang(zh-TW),
        &:lang(zh-HK) {
            font-family: 'Rakuten Sans UI Semi-Bold', 'Noto Sans TC', 'Noto Sans SC', 'Noto Sans JP',
                sans-serif;
        }
        &:lang(ko) {
            font-family: 'Ko UI', sans-serif;
        }
    `,
};

export const TEXT_TO_LOWERCASE: CSSProperties = {
    textTransform: 'lowercase',
};
